// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content {
  text-align: center;
  align-items: center;
}
.button-63 {
  align-items: center;
  background-color: #007bff;
  border: 0;
  border-radius: 8px;
  box-shadow: rgba(151, 65, 252, 0.2) 0 15px 30px -5px;
  box-sizing: border-box;
  color: #FFFFFF;
  font-family: Phantomsans, sans-serif;
  font-size: 20px;
  justify-content: center;
  line-height: 1em;
  min-width: 140px;
  display: inline-block;
  padding: 19px 24px;
  text-decoration: none;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  white-space: nowrap;
  cursor: pointer;
}
.button-62 {
  align-items: center;
  background-color: #007bff;
  border: 0;
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 10px;
  box-shadow: rgba(151, 65, 252, 0.2) 0 15px 30px -5px;
  box-sizing: border-box;
  color: #FFFFFF;
  font-family: Phantomsans, sans-serif;
  font-size: 17px;
  justify-content: center;
  line-height: 1em;
  min-width: 100px;
  display: inline-block;
  padding: 19px 24px;
  text-decoration: none;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  white-space: nowrap;
}
.button-62z {
  align-items: center;
  background-color: #007bff;
  border: 0;
  margin-left: 10px;
  position: relative;
  z-index: 20;
  margin-right: 10px;
  border-radius: 10px;
  box-shadow: rgba(151, 65, 252, 0.2) 0 15px 30px -5px;
  box-sizing: border-box;
  color: #FFFFFF;
  font-family: Phantomsans, sans-serif;
  font-size: 17px;
  justify-content: center;
  line-height: 1em;
  min-width: 100px;
  display: inline-block;
  padding: 19px 24px;
  text-decoration: none;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  white-space: nowrap;
  cursor: pointer;
}
.button-61 {
  align-items: center;
  background-color: #007bff;
  border: 0;
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 10px;
  box-shadow: rgba(151, 65, 252, 0.2) 0 15px 30px -5px;
  box-sizing: border-box;
  color: #FFFFFF;
  font-family: Phantomsans, sans-serif;
  font-size: 17px;
  justify-content: center;
  line-height: 1em;
  min-width: 100px;
  display: inline-block;
  padding: 19px 24px;
  text-decoration: none;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  white-space: nowrap;
  cursor: pointer;
}
.button-63:active,
.button-63:hover {
  outline: 0;
}

@media (min-width: 768px) {
  .button-63 {
    font-size: 24px;
    min-width: 196px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,oDAAoD;EACpD,sBAAsB;EACtB,cAAc;EACd,oCAAoC;EACpC,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,oDAAoD;EACpD,sBAAsB;EACtB,cAAc;EACd,oCAAoC;EACpC,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,oDAAoD;EACpD,sBAAsB;EACtB,cAAc;EACd,oCAAoC;EACpC,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,oDAAoD;EACpD,sBAAsB;EACtB,cAAc;EACd,oCAAoC;EACpC,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;AACjB;AACA;;EAEE,UAAU;AACZ;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF","sourcesContent":[".content {\n  text-align: center;\n  align-items: center;\n}\n.button-63 {\n  align-items: center;\n  background-color: #007bff;\n  border: 0;\n  border-radius: 8px;\n  box-shadow: rgba(151, 65, 252, 0.2) 0 15px 30px -5px;\n  box-sizing: border-box;\n  color: #FFFFFF;\n  font-family: Phantomsans, sans-serif;\n  font-size: 20px;\n  justify-content: center;\n  line-height: 1em;\n  min-width: 140px;\n  display: inline-block;\n  padding: 19px 24px;\n  text-decoration: none;\n  user-select: none;\n  -webkit-user-select: none;\n  touch-action: manipulation;\n  white-space: nowrap;\n  cursor: pointer;\n}\n.button-62 {\n  align-items: center;\n  background-color: #007bff;\n  border: 0;\n  margin-left: 10px;\n  margin-right: 10px;\n  border-radius: 10px;\n  box-shadow: rgba(151, 65, 252, 0.2) 0 15px 30px -5px;\n  box-sizing: border-box;\n  color: #FFFFFF;\n  font-family: Phantomsans, sans-serif;\n  font-size: 17px;\n  justify-content: center;\n  line-height: 1em;\n  min-width: 100px;\n  display: inline-block;\n  padding: 19px 24px;\n  text-decoration: none;\n  user-select: none;\n  -webkit-user-select: none;\n  touch-action: manipulation;\n  white-space: nowrap;\n}\n.button-62z {\n  align-items: center;\n  background-color: #007bff;\n  border: 0;\n  margin-left: 10px;\n  position: relative;\n  z-index: 20;\n  margin-right: 10px;\n  border-radius: 10px;\n  box-shadow: rgba(151, 65, 252, 0.2) 0 15px 30px -5px;\n  box-sizing: border-box;\n  color: #FFFFFF;\n  font-family: Phantomsans, sans-serif;\n  font-size: 17px;\n  justify-content: center;\n  line-height: 1em;\n  min-width: 100px;\n  display: inline-block;\n  padding: 19px 24px;\n  text-decoration: none;\n  user-select: none;\n  -webkit-user-select: none;\n  touch-action: manipulation;\n  white-space: nowrap;\n  cursor: pointer;\n}\n.button-61 {\n  align-items: center;\n  background-color: #007bff;\n  border: 0;\n  margin-left: 10px;\n  margin-right: 10px;\n  border-radius: 10px;\n  box-shadow: rgba(151, 65, 252, 0.2) 0 15px 30px -5px;\n  box-sizing: border-box;\n  color: #FFFFFF;\n  font-family: Phantomsans, sans-serif;\n  font-size: 17px;\n  justify-content: center;\n  line-height: 1em;\n  min-width: 100px;\n  display: inline-block;\n  padding: 19px 24px;\n  text-decoration: none;\n  user-select: none;\n  -webkit-user-select: none;\n  touch-action: manipulation;\n  white-space: nowrap;\n  cursor: pointer;\n}\n.button-63:active,\n.button-63:hover {\n  outline: 0;\n}\n\n@media (min-width: 768px) {\n  .button-63 {\n    font-size: 24px;\n    min-width: 196px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
